import React, { useState } from 'react';
import './styles/Kontaktformular.css';
import CTAButton from './CTAButton';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';

const tomFormular = {
  navn: '',
  email: '',
  telefon: '',
  besked: ''
};

// Brugerinput indsættes i en HTML-mail, så det skal escapes
const escapeHtml = (tekst) =>
  tekst
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
    .replace(/\n/g, '<br />');

function Kontaktformular({ titel = 'Kontakt os' }) {
  const [formData, setFormData] = useState(tomFormular);
  const [status, setStatus] = useState('klar'); // klar | sender | sendt | fejl

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sender');
    try {
      const mailRef = collection(db, 'mail');
      await addDoc(mailRef, {
        to: ['jbc@jbcentreprenoeren.dk'],
        replyTo: formData.email,
        message: {
          subject: `Ny henvendelse fra ${formData.navn}`,
          html: `
            <h2>Ny kontaktformular henvendelse</h2>
            <p><strong>Navn:</strong> ${escapeHtml(formData.navn)}</p>
            <p><strong>Email:</strong> ${escapeHtml(formData.email)}</p>
            <p><strong>Telefon:</strong> ${escapeHtml(formData.telefon)}</p>
            <p><strong>Besked:</strong></p>
            <p>${escapeHtml(formData.besked)}</p>
          `
        }
      });

      setFormData(tomFormular);
      setStatus('sendt');
    } catch (error) {
      console.error('Fejl ved afsendelse:', error);
      setStatus('fejl');
    }
  };

  return (
    <form className="kontaktformular" onSubmit={handleSubmit}>
      <h2>{titel}</h2>
      <div className="form-group">
        <label htmlFor="navn">Navn</label>
        <input
          type="text"
          id="navn"
          name="navn"
          autoComplete="name"
          value={formData.navn}
          onChange={handleChange}
          required
        />
      </div>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="email">E-mail</label>
          <input
            type="email"
            id="email"
            name="email"
            autoComplete="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="telefon">
            Telefon <span className="form-valgfri">(valgfri)</span>
          </label>
          <input
            type="tel"
            id="telefon"
            name="telefon"
            autoComplete="tel"
            value={formData.telefon}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="besked">Hvad drejer opgaven sig om?</label>
        <textarea
          id="besked"
          name="besked"
          value={formData.besked}
          onChange={handleChange}
          placeholder="Fx type opgave, adresse og hvornår det skal laves"
          required
        ></textarea>
      </div>
      <div className="form-submit">
        <CTAButton
          type="submit"
          text={status === 'sender' ? 'Sender…' : 'Send besked'}
          disabled={status === 'sender'}
        />
      </div>
      <p className={`form-status form-status--${status}`} role="status" aria-live="polite">
        {status === 'sendt' && 'Tak for din henvendelse! Vi vender tilbage hurtigst muligt.'}
        {status === 'fejl' && (
          <>
            Der skete desværre en fejl. Prøv igen, eller ring på <a href="tel:+4522780476">22 78 04 76</a>.
          </>
        )}
      </p>
    </form>
  );
}

export default Kontaktformular;
